export class Participant {
  id: string;
  eventId: string;
  bib: string;
  tag: string;
  name: string;
  surname: string;
  club: string;
  phone: string;
  dateOfBirth: string;
  gender: string;
  category: string;
  event: string = "";
  uin: string;
  externalId: string;
  isFromOtherEvent: boolean = false;
  eventName: string;
  eventShortName: string;
  estimatedStart: string;
  participantIds?: string[];
  issuanceStatus?: 'issued' | 'not_issued';
  issuedAt?: string;
  issuedBy?: string;
}

export class Team {
  name: string;
  participants: Participant[] = [];
  areBibsAssigned: boolean = false;
  constructor() {
    this.participants = []
  }

  updateBibStatus() {
    this.areBibsAssigned = this.participants.every(participant =>
      participant.bib && participant.bib.trim() !== '' && participant.bib !== '0'
    );
  }
}

export class Event {
  id: string;
  name: string;
  published: string;
  eventConfig: EventConfig;
  type: string;

  constructor(
    id,
    name,
    visible
  ) {
    this.id = id;
    this.name = name;
    this.published = visible;
  }
}

export class EventConfig {
  distances: Distance[]
}

export class Distance {
  name: string;
  offlineRegistrationEndsAt: string;
  estimatedStartTimestamp: string;
  categories: Category[];
}

export class Category{
  name: string;
  gender: string;
  ageFrom: string;
  ageTo: string;
  birthDateFrom: string;
  birthDateTo: string;
  useRaceDate: string;
}

export class AppPreferences {
  token: string;
  sessions: Session[] = []
}

export class Session {
  id: string;
  token: string;
  userData: Account;
  timestamp: number;

  constructor(
    token: string
  ) {
    this.token = token
  }
}

export class Account {
  username: string;
  role: UserRoles = UserRoles.user;
}

export enum UserRoles {
  user = "user",
  admin = "admin",
  super_admin = "super_admin",
}

export class TagBib {
  id: string;
  bib: string;
  tag: string;
  eventId: string;
  usedByParticipant: string;
  updatedAt: string;
}

export class Log {
  id: string;
  timestamp: string;
  user: string;
  type: string;
  action: string;
  data: any;
}

export interface FilterQuery {
  type?: string;
  action?: string;
  userId?: string;
  fromTimestamp?: string;
  toTimestamp?: string;
}

export class User {
  id: number;
  username: string;
  token: string;
  events: number[];
  role: string;
  constructor() {
    this.username = "";
    this.token = "";
    this.events = [];
    this.role = "user"
  }
}

export class PageContent{
  content: Log[];
  page: PageInfo;
}

export class PageInfo{
  size: number;
  totalElements: number;
  totalPages: number;
  number: number;

  constructor() {
    this.size = 0;
    this.totalPages = 0;
    this.totalElements = 0;
    this.number = 0
  }
}

export interface FileColumn {
  name: string;
  mappedField: string;
  selected: boolean;
}

export interface ParticipantField {
  key: string;
  displayName: string;
  description: string;
  required: boolean;
}
